<template>
  <section class="batch-modify size-batch" :class="{ 'size-batch--scheduled': scheduled }">
    <header class="batch-head">
      <div class="crumb">
        <button class="plain" :disabled="locked" @click="$emit('back')">‹ 返回</button>
        <span>商品工作台　›　批量修改　›　<strong>尺码表</strong></span>
      </div>
      <h1>批量修改尺码表</h1>
      <nav>
        <button
          v-for="tab in tabs"
          :key="tab[0]"
          :disabled="locked"
          :class="{ active: selectionMode === tab[0] }"
          @click="changeSelection(tab[0])"
        >
          {{ tab[1] }}
        </button>
      </nav>
    </header>
    <main>
      <p v-if="optionsError" role="alert" class="load-error">{{ optionsError }}</p>
      <section class="panel">
        <div v-if="selectionMode === 'range'" class="filters" @keyup.enter="loadPreview(1)">
          <label v-for="field in filterFields" :key="field.key" class="field"
            ><span>{{ field.label }}</span>
            <doudian-category-cascader
              v-if="field.key === 'category_id'"
              v-model="filters.category_id"
              :categories="categoryTree"
              :disabled="locked"
            />
            <el-date-picker
              v-else-if="field.date"
              v-model="filters[field.key]"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :disabled="locked"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            />
            <div v-else-if="field.matchKey" class="combined-control">
              <el-select v-model="filters[field.matchKey]" :disabled="locked">
                <el-option
                  v-for="option in field.matchOptions"
                  :key="option.value"
                  :value="option.value"
                  :label="option.label"
                />
              </el-select>
              <div v-if="field.range" class="range">
                <input v-model="filters[field.key + '_min']" :disabled="locked" placeholder="最小值" /><span>~</span>
                <input v-model="filters[field.key + '_max']" :disabled="locked" placeholder="最大值" />
              </div>
              <input
                v-else
                v-model="filters[field.key]"
                :disabled="locked"
                :placeholder="field.placeholder || '请输入' + field.label"
              />
            </div>
            <div v-else-if="field.range" class="range">
              <input v-model="filters[field.key + '_min']" :disabled="locked" placeholder="最小值" /><span>~</span>
              <input v-model="filters[field.key + '_max']" :disabled="locked" placeholder="最大值" />
            </div>
            <el-select v-else-if="field.options" v-model="filters[field.key]" :disabled="locked" clearable
              ><el-option v-for="o in field.options" :key="String(o.value)" :value="o.value" :label="o.label"
            /></el-select>
            <input
              v-else
              v-model="filters[field.key]"
              :disabled="locked"
              :placeholder="field.placeholder || '请输入'"
            />
          </label>
        </div>
        <div v-else-if="selectionMode === 'products'" class="picked">
          <button :disabled="locked || !targetShops.length" @click="openProducts">选择商品</button
          ><span>已选择 {{ selected.length }} 件（可跨店累积）</span>
        </div>
        <div v-else class="ids">
          <label for="size-product-ids">抖店商品 ID</label>
          <el-input
            id="size-product-ids"
            v-model="idsText"
            type="textarea"
            :rows="3"
            :disabled="locked"
            placeholder="输入抖店商品 ID，空格、逗号或换行分隔，最多2000个"
          />
        </div>
        <footer class="filter-actions">
          <div class="shops">
            <span><span class="required">*</span> 店铺</span>
            <el-select
              v-model="targetShops"
              multiple
              collapse-tags
              filterable
              :disabled="locked || optionsLoading"
              placeholder="请选择目标抖店（可多选）"
              @change="changeTargets"
            >
              <el-option v-for="shop in shops" :key="shop.shop_id" :label="shop.shop_name" :value="shop.shop_id" />
            </el-select>
            <button class="plain" :disabled="locked || optionsLoading" @click="loadOptions">
              {{ optionsLoading ? '加载中…' : '刷新店铺和类目' }}
            </button>
          </div>
          <div class="filter-buttons">
            <button :disabled="locked || loading" @click="loadPreview(1)">查询</button>
            <button class="plain" :disabled="locked" @click="resetFilters">重置</button>
          </div>
        </footer>
        <p class="hint">按本地数据筛选，执行时读取抖店详情逐件复核。</p>
      </section>
      <section class="panel methods">
        <h3><i></i>修改内容</h3>
        <div class="method-body">
          <div class="size-batch__methods">
            <div class="size-batch__method">
              <el-radio
                v-model="method"
                label="repair_required"
                name="size-chart-method"
                :disabled="locked"
                @change="changeMethod"
                >方式1：必填非法修复</el-radio
              >
              <p class="hint size-batch__method-options">
                执行时逐件读取商品实际尺码表；正常或非必填直接跳过，仅对必填且缺失/非法的表智能生成。
              </p>
            </div>
            <div v-for="option in templateMethods" :key="option.value" class="size-batch__method">
              <el-radio
                v-model="method"
                :label="option.value"
                name="size-chart-method"
                :disabled="locked"
                @change="changeMethod"
                >{{ option.label }}</el-radio
              >
              <div class="size-batch__method-options">
                <div class="size-batch__row">
                  <el-radio-group
                    v-model="methodOptions[option.value].action"
                    :disabled="locked || method !== option.value"
                    @change="invalidate"
                    ><el-radio label="add">增加尺码表</el-radio><el-radio label="replace">替换尺码表</el-radio
                    ><el-radio label="remove">删除尺码表</el-radio></el-radio-group
                  >
                </div>
                <div v-if="methodOptions[option.value].action === 'replace'" class="size-batch__row">
                  <span>没有尺码表时</span
                  ><el-radio-group
                    v-model="methodOptions[option.value].missingPolicy"
                    :disabled="locked || method !== option.value || methodOptions[option.value].action !== 'replace'"
                    ><el-radio label="skip">跳过不处理</el-radio
                    ><el-radio label="apply">也替换为新尺码表</el-radio></el-radio-group
                  >
                </div>
                <el-checkbox
                  v-if="methodOptions[option.value].action !== 'remove'"
                  v-model="methodOptions[option.value].trim"
                  :disabled="locked || method !== option.value || methodOptions[option.value].action === 'remove'"
                  >删除尺码表中商品未使用的多余尺码（不删除商品 SKU）</el-checkbox
                >
                <template v-if="methodOptions[option.value].action !== 'remove' || option.value === 'single_template'">
                  <div
                    v-for="(mapping, index) in methodOptions[option.value].mappings"
                    :key="mapping.key"
                    class="size-batch__mapping"
                  >
                    <button
                      v-if="methodOptions[option.value].action !== 'remove'"
                      class="plain"
                      :disabled="locked || method !== option.value || methodOptions[option.value].action === 'remove'"
                      @click="openTemplates(index)"
                    >
                      {{ mapping.template ? '重新选择尺码表' : '选择来源尺码表' }}
                    </button>
                    <el-cascader
                      v-model="mapping.category_id"
                      :options="categoryTree"
                      :props="categoryProps"
                      filterable
                      clearable
                      :disabled="
                        locked ||
                        method !== option.value ||
                        (option.value === 'category_templates' && methodOptions[option.value].action === 'remove')
                      "
                      placeholder="选择目标叶子类目"
                      @change="loadCategoryHint(mapping.category_id)"
                    />
                    <div v-if="mapping.category_id" class="size-batch__category-hint" role="status" aria-live="polite">
                      <span
                        class="size-batch__category-status"
                        :class="categoryHint(mapping.category_id).status"
                        :title="
                          categoryHint(mapping.category_id).synced_at
                            ? '本地同步时间：' + categoryHint(mapping.category_id).synced_at
                            : ''
                        "
                      >
                        <i
                          v-if="categoryHint(mapping.category_id).loading"
                          class="el-icon-loading"
                          aria-hidden="true"
                        ></i>
                        {{ categoryHint(mapping.category_id).label }}
                      </span>
                      <small>{{ categoryHint(mapping.category_id).message }}</small>
                      <button
                        v-if="
                          categoryHint(mapping.category_id).status === 'unknown' &&
                          !categoryHint(mapping.category_id).loading
                        "
                        class="plain"
                        :disabled="locked"
                        @click="loadCategoryHint(mapping.category_id, true)"
                      >
                        重试
                      </button>
                    </div>
                    <template v-if="methodOptions[option.value].action !== 'remove' && mapping.template"
                      ><doudian-size-chart-preview :chart="mapping.template.chart" /><small
                        >来源：{{ shopName(mapping.template.source_shop_id) }}<br />{{ mapping.template.name }}（{{
                          mapping.template.template_id
                        }}）</small
                      ></template
                    >
                    <button
                      class="plain"
                      v-if="option.value === 'category_templates'"
                      :disabled="locked || method !== option.value || methodOptions[option.value].action === 'remove'"
                      @click="methodOptions[option.value].mappings.splice(index, 1)"
                    >
                      移除此类目
                    </button>
                  </div>
                </template>
                <button
                  class="plain"
                  v-if="option.value === 'category_templates' && methodOptions[option.value].action !== 'remove'"
                  :disabled="
                    locked ||
                    method !== option.value ||
                    methodOptions[option.value].action === 'remove' ||
                    methodOptions[option.value].mappings.length >= 100
                  "
                  @click="addMapping"
                >
                  ＋增加类目尺码表
                </button>
                <p v-if="methodOptions[option.value].action === 'add'" class="hint">
                  没有尺码表才增加，已有尺码表整件跳过。将来源尺码表复制到需要修改的目标店铺，原模板和详情图片保留。
                </p>
                <p v-else-if="methodOptions[option.value].action === 'replace'" class="hint">
                  已有尺码表替换为新表，无表商品按所选策略处理。将来源尺码表复制到目标店铺，原模板和详情图片保留。
                </p>
                <p v-else class="hint">
                  删除商品绑定的尺码表；必填类目的商品修改失败，无尺码表的商品跳过。店铺模板和详情图片保留。
                </p>
              </div>
            </div>
          </div>
          <div class="size-batch__row">
            <span>同步调整上下架</span
            ><el-select v-model="shelfAction" :disabled="locked"
              ><el-option :value="0" label="不调整上下架" /><el-option :value="1" label="上架" /><el-option
                :value="2"
                label="下架" /></el-select
            ><small>主动作跳过时不执行上下架。</small>
          </div>
        </div>
      </section>
      <p v-if="uncertain" class="load-error" role="alert">创建响应未知，设置已锁定，请确认结果，避免重复创建。</p>
      <section v-if="previewCurrent" class="panel preview">
        <header class="preview-summary">
          <span
            >候选 <b>{{ preview.total }}</b> 件 / 本次提交 {{ preview.selected_total }} 件</span
          >
          <button class="plain" :disabled="locked" @click="invalidate">收起预览</button>
        </header>
        <p class="hint size-batch__preview-hint">本地快照仅供参考，执行时逐件实时检查；“待核验”不代表会修改。</p>
        <p v-if="missingProductIds.length" class="load-error size-batch__preview-hint" role="alert">
          当前店铺范围未找到 {{ missingProductIds.length }} 个商品 ID：{{ missingProductIds.slice(0, 10).join('、')
          }}{{ missingProductIds.length > 10 ? '…' : '' }}。请检查店铺、商品 ID 或同步状态后重新预览。
        </p>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>商品</th>
                <th>店铺</th>
                <th>原尺码表</th>
                <th>预计处理</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in preview.list" :key="row.id" :class="{ excluded: row.is_excluded }">
                <td>
                  <div class="preview-product">
                    <el-image class="preview-product-image" :src="row.main_image" fit="cover">
                      <span slot="error">暂无图片</span>
                    </el-image>
                    <div>
                      <p>{{ row.product_title }}</p>
                      <small>商品 ID：{{ row.platform_product_id }}</small>
                    </div>
                  </div>
                </td>
                <td>{{ row.shop_name }}</td>
                <td>
                  <doudian-size-chart-preview :chart="row.old_values && row.old_values.chart" /><small>{{
                    (row.old_values && row.old_values.size_info_template_id) || '待实时核验'
                  }}</small>
                </td>
                <td>
                  {{ labels[row.preview_result] }}<small>{{ row.reason_text }}</small>
                </td>
                <td>
                  <el-checkbox :value="Boolean(row.is_excluded)" :disabled="locked || loading" @change="exclude(row)"
                    >排除修改</el-checkbox
                  >
                </td>
              </tr>
              <tr v-if="!preview.list.length">
                <td colspan="5">暂无商品</td>
              </tr>
            </tbody>
          </table>
        </div>
        <footer class="preview-pagination">
          <el-pagination
            small
            :disabled="locked || loading"
            :current-page="preview.page || page"
            :page-size="20"
            :total="preview.total"
            layout="prev, pager, next, total"
            @current-change="loadPreview"
          />
        </footer>
      </section>
    </main>
    <footer class="actions">
      <button class="preview-button" :disabled="locked || loading" @click="loadPreview(1)">
        {{ loading ? '加载中…' : '修改内容预览' }}
      </button>
      <button v-if="uncertain" class="start" :disabled="submitting" @click="retryCreate">确认创建结果</button>
      <button
        v-else
        class="start"
        :disabled="locked || loading || !previewCurrent || !preview.selected_total || missingProductIds.length > 0"
        @click="submit"
      >
        {{ submitting ? '创建中…' : '开始批量修改' }}
      </button>
      <label><input v-model="scheduled" type="checkbox" :disabled="locked" /> 定时执行</label>
      <el-date-picker
        v-if="scheduled"
        v-model="scheduledAt"
        :disabled="locked"
        type="datetime"
        value-format="yyyy-MM-dd HH:mm:ss"
        placeholder="选择北京时间"
      />
    </footer>
    <doudian-size-template-selector-dialog
      :visible="templateVisible"
      :shops="shops"
      @close="templateVisible = false"
      @confirm="selectTemplate"
    />
    <product-selector-dialog
      @page-size-change="changeSelectorPageSize"
      :product-id="(p) => String(p.id)"
      :product-key="(p) => String(p.id)"
      :product-title="(p) => p.product_title || p.title || ''"
      :product-image="(p) => p.main_image || p.img || ''"
      :product-price="(p) => (p.product_price == null ? '' : '¥' + p.product_price)"
      :total-pages="Math.max(1, Math.ceil(selectorTotal / selectorPageSize))"
      :page-sizes="[20, 50, 100, 500, 1000]"
      :jump-page="selectorPage"
      @jump-input="selectorPage = Number($event)"
      @jump="loadProducts(selectorPage)"
      :visible="selectorVisible"
      :products="selectorTab === 'selected' ? draftSelected : selectorRows"
      :selected-ids="draftSelected.map((x) => String(x.id))"
      :active-tab="selectorTab"
      :page="selectorPage"
      :page-size="selectorPageSize"
      :total="selectorTotal"
      :loading="selectorLoading"
      :page-fully-selected="
        selectorRows.length > 0 && selectorRows.every((x) => draftSelected.some((y) => y.id === x.id))
      "
      @close="
        selectorVisible = false
        selectorRequest++
      "
      @tab-change="selectorTab = $event"
      @toggle-product="toggleProduct"
      @toggle-page="togglePage"
      @page-change="loadProducts"
      @confirm="confirmProducts"
    >
      <template #filters
        ><div class="size-batch__row">
          <el-select v-model="selectorShop" placeholder="查询店铺" @change="loadProducts(1)"
            ><el-option
              v-for="shop in shops.filter((x) => targetShops.includes(x.shop_id))"
              :key="shop.shop_id"
              :value="shop.shop_id"
              :label="shop.shop_name" /></el-select
          ><el-input v-model="selectorTitle" placeholder="商品标题" /><button @click="loadProducts(1)">查询</button>
        </div></template
      >
    </product-selector-dialog>
  </section>
</template>

<script>
import {
  getDoudianSizeChartShops,
  getDoudianSizeChartCategoryRule,
  previewDoudianSizeChartBatch,
  createDoudianSizeChartBatch,
  getDoudianCategories,
  getProductSelectorProducts
} from '@/api/main/doudianBatchEdit'
import DoudianSizeChartPreview from '@/components/DoudianSizeChartPreview.vue'
import DoudianSizeTemplateSelectorDialog from '@/components/DoudianSizeTemplateSelectorDialog.vue'
import DoudianCategoryCascader from '@/components/DoudianCategoryCascader'
import ProductSelectorDialog from '@/components/ProductSelectorDialog/ProductSelectorDialog'
import { fields, defaults, buildBatchProductFilter } from './batchModifyFilters'
const uuid = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    return (c === 'x' ? r : (r & 3) | 8).toString(16)
  })
const mapping = () => ({ key: uuid(), category_id: null, template: null })
const templateSettings = () => ({ action: 'add', missingPolicy: 'skip', trim: true, mappings: [mapping()] })
export default {
  name: 'BatchModifySizeChart',
  components: {
    DoudianSizeChartPreview,
    DoudianSizeTemplateSelectorDialog,
    DoudianCategoryCascader,
    ProductSelectorDialog
  },
  data: () => ({
    tabs: [
      ['range', '按范围修改'],
      ['products', '按商品修改'],
      ['product_ids', '按商品 ID 修改']
    ],
    selectionMode: 'range',
    targetShops: [],
    shops: [],
    categoryTree: [],
    categoryHints: {},
    optionsLoading: false,
    optionsError: '',
    optionsRequest: 0,
    categoryProps: {
      value: 'category_id',
      label: 'category_name',
      children: 'children',
      emitPath: false
    },
    filters: defaults(),
    selected: [],
    excluded: [],
    idsText: '',
    method: 'repair_required',
    templateMethods: [
      { value: 'single_template', label: '方式2：单类目' },
      { value: 'category_templates', label: '方式3：多类目' }
    ],
    methodOptions: { single_template: templateSettings(), category_templates: templateSettings() },
    shelfAction: 0,
    scheduled: false,
    scheduledAt: '',
    templateVisible: false,
    mappingIndex: 0,
    preview: null,
    signature: '',
    page: 1,
    loading: false,
    previewRequest: 0,
    requestId: uuid(),
    confirming: false,
    submitting: false,
    uncertain: false,
    frozenBody: null,
    selectorVisible: false,
    selectorShop: null,
    selectorTitle: '',
    selectorRows: [],
    selectorPageSize: 20,
    draftSelected: [],
    selectorTab: 'all',
    selectorPage: 1,
    selectorTotal: 0,
    selectorLoading: false,
    selectorRequest: 0,
    labels: {
      ready: '预计命中',
      skipped: '预计跳过',
      unknown: '待核验',
      failed: '预计失败'
    }
  }),
  computed: {
    activeMethodOptions() {
      return this.methodOptions[this.method] || this.methodOptions.single_template
    },
    action: {
      get() {
        return this.activeMethodOptions.action
      },
      set(value) {
        this.activeMethodOptions.action = value
      }
    },
    missingPolicy: {
      get() {
        return this.activeMethodOptions.missingPolicy
      },
      set(value) {
        this.activeMethodOptions.missingPolicy = value
      }
    },
    trim: {
      get() {
        return this.activeMethodOptions.trim
      },
      set(value) {
        this.activeMethodOptions.trim = value
      }
    },
    mappings: {
      get() {
        return this.activeMethodOptions.mappings
      },
      set(value) {
        this.activeMethodOptions.mappings = value
      }
    },
    locked() {
      return this.confirming || this.submitting || this.uncertain
    },
    filterFields() {
      return fields.filter((f) => !['quality', 'has_exposure'].includes(f.key))
    },
    previewCurrent() {
      return !!this.preview && this.signature === JSON.stringify(this.payload(false))
    },
    missingProductIds() {
      return (this.preview && this.preview.missing_product_ids) || []
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.invalidate()
      }
    },
    methodOptions: {
      deep: true,
      handler() {
        this.invalidate()
      }
    },
    idsText() {
      this.invalidate()
    },
    missingPolicy() {
      this.invalidate()
    },
    trim() {
      this.invalidate()
    },
    shelfAction() {
      this.invalidate()
    },
    scheduled() {
      if (!this.scheduled) this.scheduledAt = ''
      this.invalidate()
    },
    scheduledAt() {
      this.invalidate()
    }
  },
  mounted() {
    this.loadOptions()
  },
  beforeDestroy() {
    this.previewRequest++
    this.selectorRequest++
    this.optionsRequest++
  },
  methods: {
    changeSelectorPageSize(size) {
      this.selectorPageSize = Number(size)
      this.selectorPage = 1
      this.loadProducts(1)
    },
    categoryHint(categoryId) {
      return (
        this.categoryHints[Number(categoryId)] || { status: 'unknown', label: '待核验', message: '本地规则尚未核验' }
      )
    },
    async loadCategoryHint(categoryId, force = false) {
      const id = Number(categoryId)
      if (!Number.isSafeInteger(id) || id <= 0 || id > 9999999999) return
      const cached = this.categoryHints[id]
      if (cached && (cached.loading || (!force && cached.status !== 'unknown'))) return
      this.$set(this.categoryHints, id, {
        status: 'unknown',
        label: '待核验',
        loading: true,
        message: '正在读取本地规则…'
      })
      try {
        const hint = this.dataOf(await getDoudianSizeChartCategoryRule({ category_id: id }))
        if (this._isDestroyed) return
        if (
          !hint ||
          hint.category_id !== id ||
          !['supported', 'required', 'unsupported', 'unknown'].includes(hint.status)
        )
          throw new Error('本地规则响应无效')
        const labels = { supported: '支持', required: '必填', unsupported: '不支持', unknown: '待核验' }
        this.$set(this.categoryHints, id, {
          ...hint,
          label: labels[hint.status],
          loading: false,
          message:
            hint.reason === 'non_leaf_category'
              ? '当前为父类目，请选择具体叶子类目'
              : hint.status === 'unknown'
              ? '本地规则缺失或不完整，执行时实时核验'
              : '本地规则参考，执行时仍会实时核验'
        })
      } catch (error) {
        if (!this._isDestroyed)
          this.$set(this.categoryHints, id, {
            status: 'unknown',
            label: '待核验',
            loading: false,
            message: '本地规则读取失败，请重试'
          })
      }
    },
    dataOf(response) {
      if (Number(response && response.code) !== 200) {
        const error = new Error((response && response.message) || '请求失败')
        error.businessFailure = true
        throw error
      }
      return response.data
    },
    message(error) {
      return (error.response && error.response.data && error.response.data.message) || error.message || '请求失败'
    },
    invalidate() {
      this.previewRequest++
      this.preview = null
      this.loading = false
      this.signature = ''
      if (!this.locked) this.requestId = uuid()
    },
    shopName(id) {
      const shop = this.shops.find((x) => x.shop_id === Number(id))
      return shop ? shop.shop_name : String(id)
    },
    async loadOptions() {
      const request = ++this.optionsRequest
      this.optionsLoading = true
      this.optionsError = ''
      try {
        const shops = this.dataOf(await getDoudianSizeChartShops())
        const tree = this.dataOf(await getDoudianCategories({ shop_type: 1 }))
        if (request !== this.optionsRequest || this._isDestroyed) return
        this.shops = shops.list || []
        const map = (rows) =>
          rows.map((x) => ({
            category_id: Number(x.category_id || x.id),
            category_name: x.category_name || x.name,
            ...(x.children && x.children.length ? { children: map(x.children) } : {})
          }))
        this.categoryTree = map(Array.isArray(tree) ? tree : tree.list || tree.data || [])
      } catch (error) {
        if (request === this.optionsRequest) this.optionsError = this.message(error)
      } finally {
        if (request === this.optionsRequest) this.optionsLoading = false
      }
    },
    changeTargets() {
      this.selected = this.selected.filter((x) => this.targetShops.includes(Number(x.shop_id)))
      this.excluded = []
      this.selectorVisible = false
      this.selectorRequest++
      this.invalidate()
    },
    changeSelection(mode) {
      this.selectionMode = mode
      this.selected = []
      this.excluded = []
      this.invalidate()
    },
    resetFilters() {
      this.filters = defaults()
      this.idsText = ''
      this.selected = []
      this.excluded = []
      this.invalidate()
    },
    changeMethod() {
      this.templateVisible = false
      this.invalidate()
    },
    addMapping() {
      this.mappings.push(mapping())
    },
    openTemplates(index) {
      this.mappingIndex = index
      this.templateVisible = true
    },
    selectTemplate(template) {
      this.$set(this.mappings[this.mappingIndex], 'template', template)
      this.templateVisible = false
    },
    payload(create) {
      const filter =
        this.selectionMode === 'range'
          ? buildBatchProductFilter(this.filters, this.targetShops, this.excluded, 'range')
          : {
              shop_ids: [...this.targetShops],
              excluded_product_ids: [...this.excluded],
              platform_product_id:
                this.selectionMode === 'products'
                  ? [...new Set(this.selected.map((x) => String(x.platform_product_id)))]
                  : [...new Set(this.idsText.split(/[,，\s]+/).filter(Boolean))]
            }
      delete filter.quality_min
      delete filter.quality_max
      delete filter.has_exposure
      let rule = { mode: this.method }
      if (this.method !== 'repair_required') {
        rule.action = this.action
        if (this.method === 'single_template') rule.category_id = this.mappings[0] && this.mappings[0].category_id
        if (this.action !== 'remove') {
          rule.trim_extra_sizes = this.trim
          if (this.action === 'replace') rule.missing_policy = this.missingPolicy
          if (this.method === 'single_template') {
            const t = this.mappings[0] && this.mappings[0].template
            rule.source = t
              ? {
                  shop_id: t.source_shop_id,
                  template_id: t.template_id,
                  content_hash: t.content_hash
                }
              : null
          } else
            rule.category_templates = this.mappings.map((x) => ({
              category_id: x.category_id,
              source_shop_id: x.template && x.template.source_shop_id,
              source_template_id: x.template && x.template.template_id,
              content_hash: x.template && x.template.content_hash
            }))
        }
      }
      const body = {
        selection_mode: this.selectionMode,
        product_filter: filter,
        size_chart_rule: rule,
        common_options: { shelf_action: this.shelfAction }
      }
      if (create) {
        body.request_id = this.requestId
        if (this.scheduled) body.scheduled_at = this.scheduledAt
      }
      return body
    },
    validate() {
      if (!this.targetShops.length) throw new Error('请选择目标店铺')
      if (this.selectionMode === 'products' && !this.selected.length) throw new Error('请选择商品')
      if (this.selectionMode === 'product_ids') {
        const ids = this.payload(false).product_filter.platform_product_id
        if (!ids.length || ids.length > 2000 || ids.some((x) => !/^[1-9][0-9]{0,199}$/.test(x)))
          throw new Error('请输入有效商品ID，最多2000个')
      }
      if (this.method !== 'repair_required') {
        if (this.action === 'remove') {
          if (this.method === 'single_template' && (!this.mappings[0] || !this.mappings[0].category_id))
            throw new Error('请选择目标叶子类目')
        } else {
          if (!this.mappings.length || this.mappings.some((x) => !x.category_id || !x.template))
            throw new Error('请为每个目标叶子类目选择来源尺码表')
          if (new Set(this.mappings.map((x) => x.category_id)).size !== this.mappings.length)
            throw new Error('目标类目不能重复')
        }
      }
      if (
        this.scheduled &&
        (!this.scheduledAt || new Date(this.scheduledAt.replace(' ', 'T') + '+08:00').getTime() <= Date.now())
      )
        throw new Error('请选择未来北京时间')
    },
    async loadPreview(page) {
      try {
        this.validate()
      } catch (error) {
        return this.$message.warning(error.message)
      }
      const body = this.payload(false),
        signature = JSON.stringify(body),
        request = ++this.previewRequest
      this.loading = true
      try {
        const data = this.dataOf(await previewDoudianSizeChartBatch({ ...body, page, limit: 20 }))
        if (request !== this.previewRequest || this._isDestroyed || signature !== JSON.stringify(this.payload(false)))
          return
        this.preview = data
        this.signature = signature
        this.page = page
      } catch (error) {
        if (request === this.previewRequest) this.$message.error(this.message(error))
      } finally {
        if (request === this.previewRequest) this.loading = false
      }
    },
    exclude(row) {
      this.excluded = row.is_excluded ? this.excluded.filter((x) => x !== row.id) : [...this.excluded, row.id]
      this.invalidate()
      this.loadPreview(this.page)
    },
    async submit() {
      if (this.locked || !this.previewCurrent) return
      if (this.missingProductIds.length) return this.$message.warning('存在未找到的商品 ID，请检查后重新预览')
      try {
        this.validate()
      } catch (error) {
        return this.$message.warning(error.message)
      }
      const signature = JSON.stringify(this.payload(false))
      this.confirming = true
      try {
        await this.$confirm(
          '将检查并处理' + this.preview.selected_total + '件商品，正常表和不命中商品会跳过。是否开始？',
          '确认批量修改',
          { type: 'warning' }
        )
        if (signature !== JSON.stringify(this.payload(false))) throw new Error('设置已变化，请重新预览')
        this.frozenBody = JSON.parse(JSON.stringify(this.payload(true)))
        await this.sendCreate()
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') this.$message.error(this.message(error))
      } finally {
        this.confirming = false
      }
    },
    async sendCreate() {
      this.submitting = true
      try {
        const data = this.dataOf(await createDoudianSizeChartBatch(this.frozenBody))
        this.uncertain = false
        this.frozenBody = null
        this.$message.success('任务已创建')
        this.$emit('created', data)
      } catch (error) {
        this.uncertain =
          !error.businessFailure &&
          !(error.response && Number(error.response.status) >= 400 && Number(error.response.status) < 500)
        if (!this.uncertain) {
          this.frozenBody = null
          this.requestId = uuid()
        }
        throw error
      } finally {
        this.submitting = false
      }
    },
    async retryCreate() {
      if (this.submitting || !this.frozenBody) return
      try {
        await this.sendCreate()
      } catch (error) {
        this.$message.error(this.message(error))
      }
    },
    openProducts() {
      this.selectorShop = this.targetShops[0]
      this.draftSelected = [...this.selected]
      this.selectorTab = 'all'
      this.selectorVisible = true
      this.loadProducts(1)
    },
    async loadProducts(page) {
      const request = ++this.selectorRequest
      this.selectorRows = []
      this.selectorTotal = 0
      this.selectorPage = page
      this.selectorLoading = false
      if (!this.selectorShop || !this.targetShops.includes(this.selectorShop)) return
      this.selectorLoading = true
      try {
        const data = this.dataOf(
          await getProductSelectorProducts({
            shop_ids: [this.selectorShop],
            product_title: this.selectorTitle,
            page,
            page_size: this.selectorPageSize
          })
        )
        if (request !== this.selectorRequest || !this.selectorVisible || this._isDestroyed) return
        this.selectorRows = data.list || []
        this.selectorTotal = Number((data.pagination && data.pagination.total) || data.total || 0)
        this.selectorPage = page
      } catch (error) {
        if (request === this.selectorRequest) this.$message.error(this.message(error))
      } finally {
        if (request === this.selectorRequest) this.selectorLoading = false
      }
    },
    toggleProduct(product) {
      if (!this.targetShops.includes(Number(product.shop_id))) return
      const index = this.draftSelected.findIndex((x) => String(x.id) === String(product.id))
      if (index < 0) this.draftSelected.push(product)
      else this.draftSelected.splice(index, 1)
    },
    togglePage() {
      const all = this.selectorRows.every((x) => this.draftSelected.some((y) => String(x.id) === String(y.id)))
      this.selectorRows.forEach((x) => {
        if (all || !this.draftSelected.some((y) => String(x.id) === String(y.id))) this.toggleProduct(x)
      })
    },
    confirmProducts() {
      this.selected = [...this.draftSelected]
      this.selectorVisible = false
      this.selectorRequest++
      this.excluded = []
      this.invalidate()
    }
  }
}
</script>

<style scoped src="./batch-modify.css"></style>
<style scoped>
.size-batch {
  min-width: 0;
  font-size: 12px;
}
.size-batch__methods {
  display: block;
  width: 100%;
  font-size: 12px;
}
.size-batch__method {
  padding: 14px 0;
  border-bottom: 1px solid #ececf2;
}
.size-batch__method-options {
  margin-left: 24px;
}
.size-batch__method-options > .size-batch__row:first-child {
  margin-top: 6px;
}
.size-batch--scheduled > main {
  padding-bottom: 125px;
}
.size-batch .shops {
  flex-wrap: wrap;
}
.size-batch .shops .el-select {
  min-width: 0;
}
.size-batch .ids label {
  flex-shrink: 0;
}
.size-batch .ids .el-textarea {
  min-width: 0;
}
.size-batch__row,
.size-batch__mapping {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin: 14px 0;
}
.size-batch__row .el-select,
.size-batch__mapping .el-cascader {
  width: 240px;
  max-width: 100%;
}
.size-batch__mapping {
  padding: 12px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fafafa;
}
.size-batch__mapping small {
  flex: 1 1 180px;
  overflow-wrap: anywhere;
}
.size-batch__mapping > button {
  flex-shrink: 0;
  white-space: nowrap;
}
.size-batch__category-hint {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  flex: 0 1 auto;
  min-width: 0;
}
.size-batch__category-hint small {
  flex: 0 1 auto;
}
.size-batch__category-status {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 4px;
  background: #f0f1f4;
  color: #909399;
  line-height: 20px;
}
.size-batch__category-status.supported {
  background: #f0f9eb;
  color: #529b2e;
}
.size-batch__category-status.required {
  background: #fdf6ec;
  color: #b88230;
}
.size-batch__category-status.unsupported {
  background: #fef0f0;
  color: #c8443c;
}
.size-batch small {
  color: #999;
  font-size: 12px;
  line-height: 20px;
}
.size-batch .preview td small {
  display: block;
  margin-top: 5px;
}
.size-batch .preview th:last-child {
  width: 90px;
}
.excluded {
  opacity: 0.5;
}
.size-batch__preview-hint {
  padding: 0 14px 10px;
}
.size-batch .actions {
  flex-wrap: wrap;
}
.size-batch .actions label {
  display: flex;
  align-items: center;
  gap: 4px;
}
.size-batch .actions .el-date-editor {
  width: 200px;
  max-width: 100%;
}
.load-error,
.required {
  color: #c8443c;
}
.size-batch ::v-deep .el-radio__label,
.size-batch ::v-deep .el-checkbox__label {
  font-size: 12px;
}
.size-batch ::v-deep .el-radio {
  margin: 6px 18px 6px 0;
  white-space: normal;
  line-height: 20px;
}
.size-batch ::v-deep .el-checkbox {
  white-space: normal;
}
@media (max-width: 600px) {
  .size-batch__method-options {
    margin-left: 0;
  }
  .size-batch .ids {
    flex-direction: column;
    align-items: stretch;
  }
  .size-batch__row .el-select,
  .size-batch__mapping .el-cascader {
    width: 100%;
  }
}
</style>
